<template>
    <v-menu ref="menu" :close-on-content-click="false" :return-value.sync="datetime" transition="scale-transition" offset-y min-width="290px">
        <template v-slot:activator="{ on }">
            <v-text-field :value="datetime ? $dayjs(datetime).format('YYYY-MM-DD HH:mm:ss') : ''" append-icon="event" readonly v-bind="$attrs" v-on="on" :class="computedClass"></v-text-field>
        </template>
        <v-date-picker v-if="type == 'date'" v-model="date" type="date" no-title scrollable @change="type = 'time'"/>
        <v-card v-if="type == 'time'">
            <v-card-title align="center">
                <v-col cols="auto"><v-select v-model="hour" :items="hours" item-text="text" item-value="value" label="시" menu-props="auto" placeholder=" " dense hide-details style="width: 80px"/></v-col>
                <v-col cols="auto"><v-select v-model="minute" :items="minutes" item-text="text" item-value="value" label="분" menu-props="auto" placeholder=" " dense hide-details style="width: 80px"/></v-col>
                <v-col cols="auto"><v-select v-model="second" :items="seconds" item-text="text" item-value="value" label="초" menu-props="auto" placeholder=" " dense hide-details style="width: 80px"/></v-col>
            </v-card-title>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <v-btn text color="primary" class="" @click="input()">확인</v-btn>
            </v-card-actions>
        </v-card>
    </v-menu>
</template>

<script>
import dayjs from "dayjs";
export default {
    props: ["value", "pathClass", "default-format"],
    data(){
        let [date, time] = (this.$props.value || dayjs().format("YYYY-MM-DD HH:mm:ss"))?.split(' ');
        let [hour, minute, second] = time.split(':');
        return {
            datetime: this.$props.value,
            
            date,
            time,
            hour,
            minute,
            second,

            type: "date"
        };
    },
    methods: {
        input(){
            this.datetime = [this.date, [this.hour, this.minute, this.second].join(':')].join(' ');
            this.$refs.menu.save(this.datetime);
            this.$emit("input", this.datetime);
            this.$emit("change", this.datetime);
            this.type = "date";
        },
        test(){
            this.type = "time";
        }
    },
    watch: {
        value(){
            let [date, time] = (this.value || dayjs().format("YYYY-MM-DD HH:mm:ss"))?.split(' ');
            let [hour, minute, second] = time.split(':');

            this.datetime = this.value;
            this.date = date;
            this.time = time;
            this.hour = hour;
            this.minute = minute;
            this.second = second;
        },
    },
    computed: {
        hours(){
            return Array(24).fill().map((_, index) => ({ text: `${String(index).padStart(2, '0')}`, value: String(index).padStart(2, '0') }) );
        },

        minutes(){
            return Array(60).fill().map((_, index) => ({ text: `${String(index).padStart(2, '0')}`, value: String(index).padStart(2, '0') }) );
        },

        seconds(){
            return Array(60).fill().map((_, index) => ({ text: `${String(index).padStart(2, '0')}`, value: String(index).padStart(2, '0') }) );
        },

        computedClass(){
            return this.pathClass?.split(" ") || [];
        }
    }
}
</script>
